/**
 * Slack-specific knowledge used by the unified-integration-card flow.
 *
 * Everything here describes the bundle: which Slack integrations are grouped
 * under the single combined card, how to identify them, and the OAuth category
 * used for the unified `all` token. Lifted out of `integration-blade-unified.vue`
 * to keep the blade itself provider-agnostic.
 */

export const SLACK_PROVIDER_NAME = 'Slack';

export const SLACK_PROVIDER_KEY = 'slack';

export const SLACK_UNIFIED_OAUTH_CATEGORY = 'all';

export const SLACK_SEND_MESSAGE_OAUTH_CATEGORY = 'send-message';

export const SLACK_VOC_OAUTH_CATEGORY = 'voc';

export const SLACK_AGENT_OAUTH_CATEGORY = 'agent';

export const SLACK_UNFURL_OAUTH_CATEGORY = 'unfurl';

export const SLACK_UNIFIED_BASE_REDIRECT_PATH = '/admin/integrations';

export const SLACK_OVERVIEW_HELP_URL = 'https://support.pendo.io/hc/articles/51264531127451-Connect-Slack-to-Pendo';

export const SLACK_BUNDLED_OAUTH_CATEGORIES = new Set([
    SLACK_AGENT_OAUTH_CATEGORY,
    SLACK_SEND_MESSAGE_OAUTH_CATEGORY,
    SLACK_UNFURL_OAUTH_CATEGORY,
    SLACK_VOC_OAUTH_CATEGORY,
]);

export const SLACK_BUNDLED_CHANNEL_POSTING_CATEGORIES = new Set([
    SLACK_SEND_MESSAGE_OAUTH_CATEGORY,
]);

export function isBundledSlackIntegration (integration) {
    return SLACK_BUNDLED_OAUTH_CATEGORIES.has(integration.oauth?.uriConfig?.category);
}

export const SLACK_PROVIDER_DESCRIPTION_KEY = 'integrationsBlade.unifiedSetup.slackProviderDescription';

export const SLACK_CHANNEL_DISCLAIMER_KEY = 'integrationsBlade.slack.channelAccessDisclaimer';

export const SLACK_BUNDLE = {
    providerName: SLACK_PROVIDER_NAME,
    providerKey: SLACK_PROVIDER_KEY,
    unifiedOauthCategory: SLACK_UNIFIED_OAUTH_CATEGORY,
    baseRedirectPath: SLACK_UNIFIED_BASE_REDIRECT_PATH,
    overviewHelpUrl: SLACK_OVERVIEW_HELP_URL,
    providerDescriptionKey: SLACK_PROVIDER_DESCRIPTION_KEY,
    channelDisclaimerKey: SLACK_CHANNEL_DISCLAIMER_KEY,
    bundledOauthCategories: SLACK_BUNDLED_OAUTH_CATEGORIES,
    channelPostingCategories: SLACK_BUNDLED_CHANNEL_POSTING_CATEGORIES,
    isBundledIntegration: isBundledSlackIntegration,
};
